import { render, staticRenderFns } from "./PdTabQuantityItem.vue?vue&type=template&id=4a18fa7a&scoped=true&"
import script from "./PdTabQuantityItem.vue?vue&type=script&lang=ts&"
export * from "./PdTabQuantityItem.vue?vue&type=script&lang=ts&"
import style0 from "./PdTabQuantityItem.vue?vue&type=style&index=0&id=4a18fa7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a18fa7a",
  null
  
)

export default component.exports